import { Injectable } from '@angular/core';
import { HttpService } from '../app/utility/http-service';

export interface FeedRequest {
  clientId: string;
  feedId: string;
}

export interface DataFeed {
  id?: string;
  clientId: string;
  sourceClientId: string;
  autoRun: boolean;
  name: string;
  executionUserId: string;
  includeCalcs: boolean;
  dashboardId: string;
  exportName?: string;
  exportPayload?: string;
}

export interface FeedConnection {
  id: string;
  name: string;
  connectionType: string;
}

export interface Client {
  id?: string;
  displayName: string;
  enabled?: boolean;
}

export interface Dashboard {
  id: string;
  title: string;
  clientId: string;
}

export interface UserInfo {
  id: string;
  username: string;
  clientId: string;
  firstName?: string | null;
  lastName?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class ClientDataFeedService {
  private readonly basePath = 'ClientSettings';

  constructor(private http: HttpService) { }

  getFeeds(clientId: string, onSuccess: (feeds: DataFeed[]) => void): void {
    this.http.get<DataFeed[]>(`${this.basePath}/GetFeeds?clientId=${clientId}`, onSuccess);
  }

  createFeed(feed: DataFeed, onSuccess: (result: any) => void): void {
    this.http.post(`${this.basePath}/CreateFeed`, onSuccess, undefined, feed);
  }

  updateFeed(feed: DataFeed, onSuccess: (result: any) => void): void {
    this.http.post(`${this.basePath}/UpdateFeed`, onSuccess, undefined, feed);
  }

  deleteFeed(request: FeedRequest, onSuccess: () => void): void {
    this.http.post(`${this.basePath}/DeleteFeed`, onSuccess, undefined, request);
  }

  getAllClients(onSuccess: (clients: Client[]) => void): void {
    this.http.get<Client[]>(`${this.basePath}/GetPossibleClients`, onSuccess);
  }

  getDashboards(clientId: string, onSuccess: (definitions: Dashboard[]) => void): void {
    this.http.get<Dashboard[]>(`${this.basePath}/GetDashboards?clientId=${clientId}`, onSuccess);
  }

  getUsers(clientId: string, onSuccess: (users: UserInfo[]) => void): void {
    this.http.get<UserInfo[]>(`${this.basePath}/GetFeedUsers?clientId=${clientId}`, onSuccess);
  }

  getConnections(clientId: string, connectionType: string, onSuccess: (connections: FeedConnection[]) => void): void {
    this.http.get<FeedConnection[]>(
      `${this.basePath}/GetFeedConnections?clientId=${clientId}&connectionType=${connectionType}`,
      onSuccess);
  }
}
